import common from './common'
import error from './error'
import companyJobList from './companyJobList'
import jobFilter from './jobFilter'
import navBar from './navBar'
import onboarding from './onboarding'
import questionnaire from './questionnaire'

export default {
  common,
  error,
  companyJobList,
  jobFilter,
  navBar,
  onboarding,
  questionnaire
}
